module.exports = __webpack_public_path__ + "media/images/badge__best-of-year-a9211c8a147937cdee2e40262e2d5097.svg";